/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import product from "../../../../models/product";
import "../../../../css/Lv2SelectOptionBtn.css";
import { order } from "../../../../models";

let $ = window.$;

class Lv2SelectOptionBtnGrey extends React.Component {
  handleClick = async e => {
    const {
      code,
      selectLv2Option,
      changeLv2SelectOptionDefault,
      clickLv2OptionToChangeLv3,
      resetQuantity
    } = this.props;

    await resetQuantity();
    await selectLv2Option(code);
    await changeLv2SelectOptionDefault(code); //更新Lv2 default 顯示
    await clickLv2OptionToChangeLv3(); //設定Lv2有被click

    if (this.props.unit.quantity > 0) {
      $(".outOfStockForm_wrap")
        .finish()
        .fadeOut();
    }
  };
  render() {
    const { name } = this.props;

    return (
      <a
        className="notAvailable blockBtn border-grey smaller"
        onClick={e => this.handleClick(e)}
      >
        <span className="notAvailable">{name}</span>
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    lv2Default: state.product.lv2Default,
    unit: state.product.productBookingUnit
  };
};

const mapDispatchToProps = () => {
  return {
    resetQuantity: () => order.actions.resetQuantity(),
    selectLv2Option: code => product.actions.selectLv2Option(code),
    changeLv2SelectOptionDefault: data =>
      product.actions.changeLv2SelectOptionDefault(data),
    clickLv2OptionToChangeLv3: () => {
      product.actions.clickLv2OptionToChangeLv3();
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lv2SelectOptionBtnGrey);
